import { CollectionCarousel } from "./collection-carousel";

customElements.define("uwp-collection-carousel", CollectionCarousel);
